import { render, staticRenderFns } from "./VOrderRefund.vue?vue&type=template&id=04d68778&scoped=true"
import script from "./VOrderRefund.vue?vue&type=script&lang=ts"
export * from "./VOrderRefund.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d68778",
  null
  
)

export default component.exports